module.exports = __webpack_public_path__ + "static/media/Inter-Italic.9cbb8f0b.woff";